import { HttpService } from "../../modules/shared/services/http.service";
import { 
  PromotionSetting, 
  PromotionSettingCreateDto, 
  PromotionSettingUpdateDto,
  PromotionSettingResponse,
  PromotionSettingLatestResponse,
  PromotionFormSetting,
  PromotionFormSettingCreateDto,
  PromotionFormSettingUpdateDto,
  PromotionFormSettingResponse,
  PromotionFormSettingLatestResponse,
  PromotionFormSettingBulkCreateRequest,
  PromotionFormSettingBulkCreateResponse,
  PromotionFormSettingBulkUpdateRequest,
  PromotionFormSettingBulkUpdateResponse
} from "../../modules/shared/model/promotion-settings.interfaces";

const headers = { "Content-Type": "application/json", "x-custom-lang": "en" } as const;

// ===== PROMOTION SETTINGS APIs =====

// Get all promotion settings with pagination
export const getPromotionSettings = async (query?: Record<string, string | number | boolean>): Promise<PromotionSettingResponse> => {
  const qs = new URLSearchParams();
  Object.entries(query || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null) qs.append(k, String(v));
  });
  const response = await HttpService.get(`api/v1/promotion-settings${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
  return response;
};

// Get latest promotion setting
export const getLatestPromotionSetting = async (): Promise<PromotionSettingLatestResponse> => {
  const response = await HttpService.get("api/v1/promotion-settings/latest", true, { "x-custom-lang": "en" });
  return response;
};

// Get promotion setting by ID
export const getPromotionSettingById = async (id: string): Promise<PromotionSetting> => {
  const response = await HttpService.get(`api/v1/promotion-settings/${id}`, true, { "x-custom-lang": "en" });
  return response;
};

// Create new promotion setting
export const createPromotionSetting = async (data: PromotionSettingCreateDto): Promise<PromotionSetting> => {
  const response = await HttpService.post("api/v1/promotion-settings", data, headers, true);
  return response;
};

// Update promotion setting
export const updatePromotionSetting = async (id: string, data: PromotionSettingUpdateDto): Promise<PromotionSetting> => {
  const response = await HttpService.patch(`api/v1/promotion-settings/${id}`, data, headers, true);
  return response;
};

// Delete promotion setting
export const deletePromotionSetting = async (id: string): Promise<void> => {
  await HttpService.deleteRecord(`api/v1/promotion-settings/${id}`, { "x-custom-lang": "en" }, true);
};

// ===== PROMOTION FORM SETTINGS APIs =====

// Get all promotion form settings with pagination
export const getPromotionFormSettings = async (query?: Record<string, string | number | boolean>): Promise<PromotionFormSettingResponse> => {
  const qs = new URLSearchParams();
  Object.entries(query || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null) qs.append(k, String(v));
  });
  const response = await HttpService.get(`api/v1/promotion-form-settings${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
  return response;
};

// Get latest promotion form setting
export const getLatestPromotionFormSetting = async (): Promise<PromotionFormSettingLatestResponse> => {
  const response = await HttpService.get("api/v1/promotion-form-settings/latest", true, { "x-custom-lang": "en" });
  return response;
};

// Get promotion form setting by ID
export const getPromotionFormSettingById = async (id: string): Promise<PromotionFormSetting> => {
  const response = await HttpService.get(`api/v1/promotion-form-settings/${id}`, true, { "x-custom-lang": "en" });
  return response;
};

// Create new promotion form setting
export const createPromotionFormSetting = async (data: PromotionFormSettingCreateDto): Promise<PromotionFormSetting> => {
  const response = await HttpService.post("api/v1/promotion-form-settings", data, headers, true);
  return response;
};

// Update promotion form setting
export const updatePromotionFormSetting = async (id: string, data: PromotionFormSettingUpdateDto): Promise<PromotionFormSetting> => {
  const response = await HttpService.patch(`api/v1/promotion-form-settings/${id}`, data, headers, true);
  return response;
};

// Delete promotion form setting
export const deletePromotionFormSetting = async (id: string): Promise<void> => {
  await HttpService.deleteRecord(`api/v1/promotion-form-settings/${id}`, { "x-custom-lang": "en" }, true);
};

// Bulk create promotion form settings
export const bulkCreatePromotionFormSettings = async (data: PromotionFormSettingBulkCreateRequest): Promise<PromotionFormSettingBulkCreateResponse> => {
  const response = await HttpService.post("api/v1/promotion-form-settings/bulk-create", data, headers, true);
  return response;
};

// Bulk update promotion form settings
export const bulkUpdatePromotionFormSettings = async (data: PromotionFormSettingBulkUpdateRequest): Promise<PromotionFormSettingBulkUpdateResponse> => {
  const response = await HttpService.patch("api/v1/promotion-form-settings/bulk-update", data, headers, true);
  return response;
};
